export * from './configuration.service';
import { ConfigurationService } from './configuration.service';
export * from './contacts.service';
import { ContactsService } from './contacts.service';
export * from './customers.service';
import { CustomersService } from './customers.service';
export * from './dataImport.service';
import { DataImportService } from './dataImport.service';
export * from './employers.service';
import { EmployersService } from './employers.service';
export * from './invoices.service';
import { InvoicesService } from './invoices.service';
export * from './orders.service';
import { OrdersService } from './orders.service';
export * from './profile.service';
import { ProfileService } from './profile.service';
export * from './reports.service';
import { ReportsService } from './reports.service';
export * from './search.service';
import { SearchService } from './search.service';
export * from './telemetry.service';
import { TelemetryService } from './telemetry.service';
export * from './turnOvers.service';
import { TurnOversService } from './turnOvers.service';
export * from './users.service';
import { UsersService } from './users.service';
export * from './visits.service';
import { VisitsService } from './visits.service';
export * from './warrantyClaims.service';
import { WarrantyClaimsService } from './warrantyClaims.service';
export const APIS = [ConfigurationService, ContactsService, CustomersService, DataImportService, EmployersService, InvoicesService, OrdersService, ProfileService, ReportsService, SearchService, TelemetryService, TurnOversService, UsersService, VisitsService, WarrantyClaimsService];
